// Holiday and School Term Data Service

const holidayData = {
  'Afghanistan': { publicHolidays: [], schoolTerms: [] },
  'Albania': { publicHolidays: [], schoolTerms: [] },
  'Algeria': { publicHolidays: [], schoolTerms: [] },
  'Andorra': { publicHolidays: [], schoolTerms: [] },
  'Angola': { publicHolidays: [], schoolTerms: [] },
  'Antigua and Barbuda': { publicHolidays: [], schoolTerms: [] },
  'Argentina': { publicHolidays: [], schoolTerms: [] },
  'Armenia': { publicHolidays: [], schoolTerms: [] },
  'Australia': {
    publicHolidays: [
      { date: '2026-01-01', name: 'New Year\'s Day', type: 'public' },
      { date: '2026-01-26', name: 'Australia Day', type: 'public' },
      { date: '2026-04-03', name: 'Good Friday', type: 'public' },
      { date: '2026-04-04', name: 'Easter Saturday', type: 'public' },
      { date: '2026-04-06', name: 'Easter Monday', type: 'public' },
      { date: '2026-04-25', name: 'Anzac Day', type: 'public' },
      { date: '2026-06-08', name: 'Queen\'s Birthday', type: 'public' },
      { date: '2026-12-25', name: 'Christmas Day', type: 'public' },
      { date: '2026-12-26', name: 'Boxing Day', type: 'public' }
    ],
    schoolTerms: [
      { startDate: '2026-01-28', endDate: '2026-04-09', name: 'Term 1', type: 'school' },
      { startDate: '2026-04-10', endDate: '2026-04-27', name: 'Autumn Break', type: 'school-break' },
      { startDate: '2026-04-28', endDate: '2026-07-03', name: 'Term 2', type: 'school' },
      { startDate: '2026-07-06', endDate: '2026-07-20', name: 'Winter Break', type: 'school-break' },
      { startDate: '2026-07-21', endDate: '2026-09-25', name: 'Term 3', type: 'school' },
      { startDate: '2026-09-28', endDate: '2026-10-12', name: 'Spring Break', type: 'school-break' },
      { startDate: '2026-10-13', endDate: '2026-12-18', name: 'Term 4', type: 'school' },
      { startDate: '2026-12-21', endDate: '2027-01-27', name: 'Summer Break', type: 'school-break' }
    ]
  },
  'Austria': { publicHolidays: [], schoolTerms: [] },
  'Azerbaijan': { publicHolidays: [], schoolTerms: [] },
  'Bahamas': { publicHolidays: [], schoolTerms: [] },
  'Bahrain': { publicHolidays: [], schoolTerms: [] },
  'Bangladesh': { publicHolidays: [], schoolTerms: [] },
  'Barbados': { publicHolidays: [], schoolTerms: [] },
  'Belarus': { publicHolidays: [], schoolTerms: [] },
  'Belgium': { publicHolidays: [], schoolTerms: [] },
  'Belize': { publicHolidays: [], schoolTerms: [] },
  'Benin': { publicHolidays: [], schoolTerms: [] },
  'Bhutan': { publicHolidays: [], schoolTerms: [] },
  'Bolivia': { publicHolidays: [], schoolTerms: [] },
  'Bosnia and Herzegovina': { publicHolidays: [], schoolTerms: [] },
  'Botswana': { publicHolidays: [], schoolTerms: [] },
  'Brazil': { publicHolidays: [], schoolTerms: [] },
  'Brunei': { publicHolidays: [], schoolTerms: [] },
  'Bulgaria': { publicHolidays: [], schoolTerms: [] },
  'Burkina Faso': { publicHolidays: [], schoolTerms: [] },
  'Burundi': { publicHolidays: [], schoolTerms: [] },
  'Cambodia': { publicHolidays: [], schoolTerms: [] },
  'Cameroon': { publicHolidays: [], schoolTerms: [] },
  'Canada': {
    publicHolidays: [
      { date: '2026-01-01', name: 'New Year\'s Day', type: 'public' },
      { date: '2026-04-03', name: 'Good Friday', type: 'public' },
      { date: '2026-05-18', name: 'Victoria Day', type: 'public' },
      { date: '2026-07-01', name: 'Canada Day', type: 'public' },
      { date: '2026-08-03', name: 'Civic Holiday', type: 'public' },
      { date: '2026-09-07', name: 'Labour Day', type: 'public' },
      { date: '2026-10-12', name: 'Thanksgiving', type: 'public' },
      { date: '2026-12-25', name: 'Christmas Day', type: 'public' },
      { date: '2026-12-26', name: 'Boxing Day', type: 'public' }
    ],
    schoolTerms: [
      { startDate: '2026-01-05', endDate: '2026-03-13', name: 'Winter Term', type: 'school' },
      { startDate: '2026-03-16', endDate: '2026-03-20', name: 'March Break', type: 'school-break' },
      { startDate: '2026-03-23', endDate: '2026-06-26', name: 'Spring Term', type: 'school' },
      { startDate: '2026-06-29', endDate: '2026-09-04', name: 'Summer Break', type: 'school-break' },
      { startDate: '2026-09-08', endDate: '2026-12-18', name: 'Fall Term', type: 'school' },
      { startDate: '2026-12-21', endDate: '2027-01-01', name: 'Winter Break', type: 'school-break' }
    ]
  },
  'Cape Verde': { publicHolidays: [], schoolTerms: [] },
  'Central African Republic': { publicHolidays: [], schoolTerms: [] },
  'Chad': { publicHolidays: [], schoolTerms: [] },
  'Chile': { publicHolidays: [], schoolTerms: [] },
  'China': { publicHolidays: [], schoolTerms: [] },
  'Colombia': { publicHolidays: [], schoolTerms: [] },
  'Comoros': { publicHolidays: [], schoolTerms: [] },
  'Congo': { publicHolidays: [], schoolTerms: [] },
  'Costa Rica': { publicHolidays: [], schoolTerms: [] },
  'Croatia': { publicHolidays: [], schoolTerms: [] },
  'Cuba': { publicHolidays: [], schoolTerms: [] },
  'Cyprus': { publicHolidays: [], schoolTerms: [] },
  'Czech Republic': { publicHolidays: [], schoolTerms: [] },
  'Denmark': { publicHolidays: [], schoolTerms: [] },
  'Djibouti': { publicHolidays: [], schoolTerms: [] },
  'Dominica': { publicHolidays: [], schoolTerms: [] },
  'Dominican Republic': { publicHolidays: [], schoolTerms: [] },
  'East Timor': { publicHolidays: [], schoolTerms: [] },
  'Ecuador': { publicHolidays: [], schoolTerms: [] },
  'Egypt': { publicHolidays: [], schoolTerms: [] },
  'El Salvador': { publicHolidays: [], schoolTerms: [] },
  'Equatorial Guinea': { publicHolidays: [], schoolTerms: [] },
  'Eritrea': { publicHolidays: [], schoolTerms: [] },
  'Estonia': { publicHolidays: [], schoolTerms: [] },
  'Eswatini': { publicHolidays: [], schoolTerms: [] },
  'Ethiopia': { publicHolidays: [], schoolTerms: [] },
  'Fiji': { publicHolidays: [], schoolTerms: [] },
  'Finland': { publicHolidays: [], schoolTerms: [] },
  'France': { publicHolidays: [], schoolTerms: [] },
  'Gabon': { publicHolidays: [], schoolTerms: [] },
  'Gambia': { publicHolidays: [], schoolTerms: [] },
  'Georgia': { publicHolidays: [], schoolTerms: [] },
  'Germany': { publicHolidays: [], schoolTerms: [] },
  'Ghana': { publicHolidays: [], schoolTerms: [] },
  'Greece': { publicHolidays: [], schoolTerms: [] },
  'Grenada': { publicHolidays: [], schoolTerms: [] },
  'Guatemala': { publicHolidays: [], schoolTerms: [] },
  'Guinea': { publicHolidays: [], schoolTerms: [] },
  'Guinea-Bissau': { publicHolidays: [], schoolTerms: [] },
  'Guyana': { publicHolidays: [], schoolTerms: [] },
  'Haiti': { publicHolidays: [], schoolTerms: [] },
  'Honduras': { publicHolidays: [], schoolTerms: [] },
  'Hungary': { publicHolidays: [], schoolTerms: [] },
  'Iceland': { publicHolidays: [], schoolTerms: [] },
  'India': { publicHolidays: [], schoolTerms: [] },
  'Indonesia': { publicHolidays: [], schoolTerms: [] },
  'Iran': { publicHolidays: [], schoolTerms: [] },
  'Iraq': { publicHolidays: [], schoolTerms: [] },
  'Ireland': { publicHolidays: [], schoolTerms: [] },
  'Israel': { publicHolidays: [], schoolTerms: [] },
  'Italy': { publicHolidays: [], schoolTerms: [] },
  'Jamaica': { publicHolidays: [], schoolTerms: [] },
  'Japan': { publicHolidays: [], schoolTerms: [] },
  'Jordan': { publicHolidays: [], schoolTerms: [] },
  'Kazakhstan': { publicHolidays: [], schoolTerms: [] },
  'Kenya': { publicHolidays: [], schoolTerms: [] },
  'Kiribati': { publicHolidays: [], schoolTerms: [] },
  'Kuwait': { publicHolidays: [], schoolTerms: [] },
  'Kyrgyzstan': { publicHolidays: [], schoolTerms: [] },
  'Laos': { publicHolidays: [], schoolTerms: [] },
  'Latvia': { publicHolidays: [], schoolTerms: [] },
  'Lebanon': { publicHolidays: [], schoolTerms: [] },
  'Lesotho': { publicHolidays: [], schoolTerms: [] },
  'Liberia': { publicHolidays: [], schoolTerms: [] },
  'Libya': { publicHolidays: [], schoolTerms: [] },
  'Liechtenstein': { publicHolidays: [], schoolTerms: [] },
  'Lithuania': { publicHolidays: [], schoolTerms: [] },
  'Luxembourg': { publicHolidays: [], schoolTerms: [] },
  'Madagascar': { publicHolidays: [], schoolTerms: [] },
  'Malawi': { publicHolidays: [], schoolTerms: [] },
  'Malaysia': { publicHolidays: [], schoolTerms: [] },
  'Maldives': { publicHolidays: [], schoolTerms: [] },
  'Mali': { publicHolidays: [], schoolTerms: [] },
  'Malta': { publicHolidays: [], schoolTerms: [] },
  'Marshall Islands': { publicHolidays: [], schoolTerms: [] },
  'Mauritania': { publicHolidays: [], schoolTerms: [] },
  'Mauritius': { publicHolidays: [], schoolTerms: [] },
  'Mexico': { publicHolidays: [], schoolTerms: [] },
  'Micronesia': { publicHolidays: [], schoolTerms: [] },
  'Moldova': { publicHolidays: [], schoolTerms: [] },
  'Monaco': { publicHolidays: [], schoolTerms: [] },
  'Mongolia': { publicHolidays: [], schoolTerms: [] },
  'Montenegro': { publicHolidays: [], schoolTerms: [] },
  'Morocco': { publicHolidays: [], schoolTerms: [] },
  'Mozambique': { publicHolidays: [], schoolTerms: [] },
  'Myanmar': { publicHolidays: [], schoolTerms: [] },
  'Namibia': { publicHolidays: [], schoolTerms: [] },
  'Nauru': { publicHolidays: [], schoolTerms: [] },
  'Nepal': { publicHolidays: [], schoolTerms: [] },
  'Netherlands': { publicHolidays: [], schoolTerms: [] },
  'New Zealand': { publicHolidays: [], schoolTerms: [] },
  'Nicaragua': { publicHolidays: [], schoolTerms: [] },
  'Niger': { publicHolidays: [], schoolTerms: [] },
  'Nigeria': { publicHolidays: [], schoolTerms: [] },
  'North Korea': { publicHolidays: [], schoolTerms: [] },
  'North Macedonia': { publicHolidays: [], schoolTerms: [] },
  'Norway': { publicHolidays: [], schoolTerms: [] },
  'Oman': { publicHolidays: [], schoolTerms: [] },
  'Pakistan': { publicHolidays: [], schoolTerms: [] },
  'Palau': { publicHolidays: [], schoolTerms: [] },
  'Palestine': { publicHolidays: [], schoolTerms: [] },
  'Panama': { publicHolidays: [], schoolTerms: [] },
  'Papua New Guinea': { publicHolidays: [], schoolTerms: [] },
  'Paraguay': { publicHolidays: [], schoolTerms: [] },
  'Peru': { publicHolidays: [], schoolTerms: [] },
  'Philippines': { publicHolidays: [], schoolTerms: [] },
  'Poland': { publicHolidays: [], schoolTerms: [] },
  'Portugal': { publicHolidays: [], schoolTerms: [] },
  'Qatar': { publicHolidays: [], schoolTerms: [] },
  'Romania': { publicHolidays: [], schoolTerms: [] },
  'Russia': { publicHolidays: [], schoolTerms: [] },
  'Rwanda': { publicHolidays: [], schoolTerms: [] },
  'Saint Kitts and Nevis': { publicHolidays: [], schoolTerms: [] },
  'Saint Lucia': { publicHolidays: [], schoolTerms: [] },
  'Saint Vincent and the Grenadines': { publicHolidays: [], schoolTerms: [] },
  'Samoa': { publicHolidays: [], schoolTerms: [] },
  'San Marino': { publicHolidays: [], schoolTerms: [] },
  'Sao Tome and Principe': { publicHolidays: [], schoolTerms: [] },
  'Saudi Arabia': { publicHolidays: [], schoolTerms: [] },
  'Senegal': { publicHolidays: [], schoolTerms: [] },
  'Serbia': { publicHolidays: [], schoolTerms: [] },
  'Seychelles': { publicHolidays: [], schoolTerms: [] },
  'Sierra Leone': { publicHolidays: [], schoolTerms: [] },
  'Singapore': { publicHolidays: [], schoolTerms: [] },
  'Slovakia': { publicHolidays: [], schoolTerms: [] },
  'Slovenia': { publicHolidays: [], schoolTerms: [] },
  'Solomon Islands': { publicHolidays: [], schoolTerms: [] },
  'Somalia': { publicHolidays: [], schoolTerms: [] },
  'South Africa': { publicHolidays: [], schoolTerms: [] },
  'South Korea': { publicHolidays: [], schoolTerms: [] },
  'South Sudan': { publicHolidays: [], schoolTerms: [] },
  'Spain': { publicHolidays: [], schoolTerms: [] },
  'Sri Lanka': { publicHolidays: [], schoolTerms: [] },
  'Sudan': { publicHolidays: [], schoolTerms: [] },
  'Suriname': { publicHolidays: [], schoolTerms: [] },
  'Sweden': { publicHolidays: [], schoolTerms: [] },
  'Switzerland': { publicHolidays: [], schoolTerms: [] },
  'Syria': { publicHolidays: [], schoolTerms: [] },
  'Taiwan': { publicHolidays: [], schoolTerms: [] },
  'Tajikistan': { publicHolidays: [], schoolTerms: [] },
  'Tanzania': { publicHolidays: [], schoolTerms: [] },
  'Thailand': { publicHolidays: [], schoolTerms: [] },
  'Togo': { publicHolidays: [], schoolTerms: [] },
  'Tonga': { publicHolidays: [], schoolTerms: [] },
  'Trinidad and Tobago': { publicHolidays: [], schoolTerms: [] },
  'Tunisia': { publicHolidays: [], schoolTerms: [] },
  'Turkey': { publicHolidays: [], schoolTerms: [] },
  'Turkmenistan': { publicHolidays: [], schoolTerms: [] },
  'Tuvalu': { publicHolidays: [], schoolTerms: [] },
  'Uganda': { publicHolidays: [], schoolTerms: [] },
  'Ukraine': { publicHolidays: [], schoolTerms: [] },
  'United Arab Emirates': { publicHolidays: [], schoolTerms: [] },
  'United Kingdom': {
    publicHolidays: [
      { date: '2026-01-01', name: 'New Year\'s Day', type: 'public' },
      { date: '2026-04-03', name: 'Good Friday', type: 'public' },
      { date: '2026-04-06', name: 'Easter Monday', type: 'public' },
      { date: '2026-05-04', name: 'Early May Bank Holiday', type: 'public' },
      { date: '2026-05-25', name: 'Spring Bank Holiday', type: 'public' },
      { date: '2026-08-31', name: 'Summer Bank Holiday', type: 'public' },
      { date: '2026-12-25', name: 'Christmas Day', type: 'public' },
      { date: '2026-12-26', name: 'Boxing Day', type: 'public' }
    ],
    schoolTerms: [
      { startDate: '2026-01-05', endDate: '2026-02-13', name: 'Spring Term 1', type: 'school' },
      { startDate: '2026-02-16', endDate: '2026-02-20', name: 'Half Term Break', type: 'school-break' },
      { startDate: '2026-02-23', endDate: '2026-04-02', name: 'Spring Term 2', type: 'school' },
      { startDate: '2026-04-06', endDate: '2026-04-17', name: 'Easter Holiday', type: 'school-break' },
      { startDate: '2026-04-20', endDate: '2026-05-22', name: 'Summer Term 1', type: 'school' },
      { startDate: '2026-05-25', endDate: '2026-05-29', name: 'Half Term Break', type: 'school-break' },
      { startDate: '2026-06-01', endDate: '2026-07-17', name: 'Summer Term 2', type: 'school' },
      { startDate: '2026-07-20', endDate: '2026-08-31', name: 'Summer Holiday', type: 'school-break' },
      { startDate: '2026-09-01', endDate: '2026-10-23', name: 'Autumn Term 1', type: 'school' },
      { startDate: '2026-10-26', endDate: '2026-10-30', name: 'Half Term Break', type: 'school-break' },
      { startDate: '2026-11-02', endDate: '2026-12-18', name: 'Autumn Term 2', type: 'school' },
      { startDate: '2026-12-21', endDate: '2027-01-01', name: 'Christmas Holiday', type: 'school-break' }
    ]
  },
  'United States': {
    publicHolidays: [
      { date: '2026-01-01', name: 'New Year\'s Day', type: 'public' },
      { date: '2026-01-19', name: 'Martin Luther King Jr. Day', type: 'public' },
      { date: '2026-02-16', name: 'Presidents\' Day', type: 'public' },
      { date: '2026-05-25', name: 'Memorial Day', type: 'public' },
      { date: '2026-07-04', name: 'Independence Day', type: 'public' },
      { date: '2026-09-07', name: 'Labor Day', type: 'public' },
      { date: '2026-10-12', name: 'Columbus Day', type: 'public' },
      { date: '2026-11-11', name: 'Veterans Day', type: 'public' },
      { date: '2026-11-26', name: 'Thanksgiving Day', type: 'public' },
      { date: '2026-12-25', name: 'Christmas Day', type: 'public' }
    ],
    schoolTerms: [
      { startDate: '2026-01-05', endDate: '2026-03-20', name: 'Winter Term', type: 'school' },
      { startDate: '2026-03-23', endDate: '2026-03-27', name: 'Spring Break', type: 'school-break' },
      { startDate: '2026-03-30', endDate: '2026-06-12', name: 'Spring Term', type: 'school' },
      { startDate: '2026-06-15', endDate: '2026-08-28', name: 'Summer Break', type: 'school-break' },
      { startDate: '2026-08-31', endDate: '2026-12-18', name: 'Fall Term', type: 'school' },
      { startDate: '2026-12-21', endDate: '2027-01-01', name: 'Winter Break', type: 'school-break' }
    ]
  },
  'Uruguay': { publicHolidays: [], schoolTerms: [] },
  'Uzbekistan': { publicHolidays: [], schoolTerms: [] },
  'Vanuatu': { publicHolidays: [], schoolTerms: [] },
  'Vatican City': { publicHolidays: [], schoolTerms: [] },
  'Venezuela': { publicHolidays: [], schoolTerms: [] },
  'Vietnam': { publicHolidays: [], schoolTerms: [] },
  'Yemen': { publicHolidays: [], schoolTerms: [] },
  'Zambia': { publicHolidays: [], schoolTerms: [] },
  'Zimbabwe': { publicHolidays: [], schoolTerms: [] }
};

export const getAvailableLocations = () => {
  return Object.keys(holidayData);
};

export const getHolidaysForLocation = (location) => {
  if (!location || !holidayData?.[location]) {
    return [];
  }
  return holidayData?.[location]?.publicHolidays || [];
};

export const getSchoolTermsForLocation = (location) => {
  if (!location || !holidayData?.[location]) {
    return [];
  }
  return holidayData?.[location]?.schoolTerms || [];
};

export const getAllHolidayEventsForLocation = (location, showPublicHolidays, showSchoolTerms) => {
  const events = [];
  
  if (showPublicHolidays) {
    const holidays = getHolidaysForLocation(location);
    events?.push(...holidays);
  }
  
  if (showSchoolTerms) {
    const terms = getSchoolTermsForLocation(location);
    events?.push(...terms);
  }
  
  return events;
};

export const isDateInRange = (date, startDate, endDate) => {
  const checkDate = new Date(date);
  const start = new Date(startDate);
  const end = new Date(endDate);
  return checkDate >= start && checkDate <= end;
};

export const getHolidaysForDate = (date, location, showPublicHolidays, showSchoolTerms) => {
  const dateStr = date?.toISOString()?.split('T')?.[0];
  const holidays = [];
  
  if (showPublicHolidays) {
    const publicHolidays = getHolidaysForLocation(location);
    const dayHolidays = publicHolidays?.filter(h => h?.date === dateStr);
    holidays?.push(...dayHolidays);
  }
  
  if (showSchoolTerms) {
    const schoolTerms = getSchoolTermsForLocation(location);
    const activeTerms = schoolTerms?.filter(term => 
      isDateInRange(dateStr, term?.startDate, term?.endDate)
    );
    holidays?.push(...activeTerms);
  }
  
  return holidays;
};